import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import { viewResourcesFormData } from "./data/ViewResourcesForm.data";
import MolGrid from "../../components/Grid/MolGrid";
import Buttons from "../../components/ui/button/Buttons";
import { ViewResourcesListConfig } from "./data/ViewResourcesListConfig";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery } from "../../app/services/common/commonApi";
import { setAllDropDownField } from "./Utils/dropDown";
import { useNavigate } from "react-router-dom";
import { encryptAESID } from "../../utils/Encryption";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import {  useDeleteResourceDetailByIdMutation, useGetAllResourcesListMutation, useDownloadAllTypesDocForResourceMutation } from "../../app/services/Resource/resourceApi";
import SwalAlert from "../../services/swalService/SwalService";

const ResourceList = () => {
  const viewResourcesRef = useRef();
  const molGridRef = useRef();
  const navigate = useNavigate();
  const { success, error, confirm } = SwalAlert()

  const [viewResourcesForm, setViewResourcesForm] = useState(viewResourcesFormData);
  const [totalRecord, setTotalRecord] = useState(0)
  const [dataSource, setDataSource] = useState([])

  const [paginationRequest, setPaginationRequest] = useState({
    pageNo: 1,
    pageSize: 20,
    category: null,
    document: "",
    membershipType: null,
  });


  const [signUpDropDownsForCorporateMembers, { data: signUpDropDownsData, isLoading: signUpDropDownsLoading, isFetching: signUpDropDownsFetching, isError: signUpDropDownsIsError, error: signUpDropDownsError, }] = useLazyGetSignUpDropDownsForCorporateMembersQuery()
  const [getAllResourcesList, { data: resourceListData, isLoading: resourceListLoading, isFetching: resourceListFetching, isError: resourceListIsError, error: resourceListError, }] = useGetAllResourcesListMutation();
  const [deleteResourceDetail, { data: deleteResorceData, isLoading: deleteResorceLoading, isFetching: deleteResorceFetching, isError: deleteResorceIsError, error: deleteResorceError, },] = useDeleteResourceDetailByIdMutation();
  const [downloadResourceDoc, { isSuccess: isDownloadSuccess, },] = useDownloadAllTypesDocForResourceMutation();





  const handleSearch = () => {
    if (!viewResourcesRef.current) {
      return
    }
    const formData = viewResourcesRef.current.getFormData();
    const updatedPaginationRequest = {
      PageNo: 1,
      PageSize: 20,
      categoryTypeId: formData?.category?.value ? formData?.category?.value : 0,
      document: formData?.document || "",
      membershipTypeId: formData?.membershipType?.value ? formData?.membershipType?.value : 0,
    };    
    setPaginationRequest(updatedPaginationRequest)
    getAllResourcesList(updatedPaginationRequest);
  }

  const handleClearClick = () => {
    const updatedFormData = { ...viewResourcesFormData };
    updatedFormData.initialState = {
      category: null,
      document: null,
      membershipType: null,
    };

    const request = {
      ...paginationRequest,
      categoryTypeId: 0,
      document: "",
      membershipTypeId: 0,
      totalCount: 0,
    };
    setPaginationRequest((prev) => ({ ...prev, ...request }));
    getAllResourcesList(request);
    setViewResourcesForm(updatedFormData);
  };

  const handlePageChange = ({ pageNumber, pageSize }) => {
    const updatedPaginationRequest = { ...paginationRequest, pageNo: pageNumber, pageSize: pageSize };
    setPaginationRequest(updatedPaginationRequest);
    getAllResourcesList(updatedPaginationRequest);
  };

  const handleViewClick = (data) => {
    navigate(`/ViewResourceDetails/${encryptAESID(data?.resourceId)}`);
  }

  const handleCreateClick = (data) => {
    navigate(`/createResources`);
  }

  const handleDeleteResource = (data) => {
    confirm("Delete", "Are you sure you want to delete", "Yes", "Cancel").then(
      (value) => {
        if (value) {
          deleteResourceDetail(data?.resourceId)
        }
      }
    );
  }

  useEffect(() => {
    signUpDropDownsForCorporateMembers()
    getAllResourcesList(paginationRequest);
  }, [])

  useEffect(() => {
    if (!signUpDropDownsLoading && signUpDropDownsData) {
      setAllDropDownField(signUpDropDownsData);
    }
  }, [signUpDropDownsLoading, signUpDropDownsData]);

   useEffect( () => {
        if ( !deleteResorceLoading && deleteResorceData ) {
            if ( deleteResorceData.hasError === false ) {
                success( "Resource Deleted Successfully" );
                getAllResourcesList( paginationRequest )
            }
            else {
                error( deleteResorceData.errorMessage )
            }
        }
    }, [ deleteResorceLoading, deleteResorceData ] );

  useEffect(() => {
    if (!resourceListLoading && resourceListData) {
      setPaginationRequest((prev) => ({
        ...prev,
        totalCount: resourceListData?.totalCount,
      }));
      setTotalRecord(resourceListData?.totalCount)
      setDataSource(resourceListData?.itemList)
    }
  }, [resourceListLoading, resourceListData]);

  
  const handleDownLoadFile = async (rowData) => {
      try {
      const filePath = rowData?.documentPath;
      
      const fileExt = filePath?.match(/\.[^.]+$/)?.[0];
      
      const req = {
        type: fileExt,
        Path: filePath,
      };
      
      const blob = await downloadResourceDoc(req).unwrap();
      
      const url = window.URL.createObjectURL(blob);
      
      const link = document.createElement("a");
      link.href = url;
  
      link.download =
        filePath
          ?.replace(/^UploadResourceDocument[\\/]/i, "")
          ?.split(/[\\/]/)
          .pop() || `resource${fileExt || ""}`;
      
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      window.URL.revokeObjectURL(url);
    } catch (err) {
      error("File not found");
    }
  };
 

  const actionHandler = {
    VIEW: handleViewClick,
    DELETE: handleDeleteResource,
    undefined : handleDownLoadFile
  };
  
  
  return (
    <>
      {signUpDropDownsData ?
        (
          <div className="view-resources">
            <div className=" payment-update-filter row">
              <div className="row status-input col-10">
                <FormCreator ref={viewResourcesRef} {...viewResourcesForm} />
              </div>
              <div className="col-2 right-side-btn mt-3 d-flex">
                <Buttons
                  buttonText="Search"
                  buttonTypeClassName="success-btn mr-2"
                  onClick={handleSearch}
                />
                <Buttons
                  buttonText="Clear"
                  buttonTypeClassName="black-btn btn"
                  onClick={handleClearClick}
                />
              </div>
            </div>
            <div className="resources-list view-resources-list">
              <div className="list-btn-sec mb-3">
                <h4>{totalRecord} Resources </h4>
                <Buttons
                  buttonText="Create New"
                  buttonTypeClassName="success-btn mr-2"
                  onClick={handleCreateClick}
                />
              </div>
              <MolGrid
                ref={molGridRef}
                configuration={ViewResourcesListConfig}
                allowPagination={true}
                onPageChange={handlePageChange}
                pagination={paginationRequest}
                dataSource={dataSource}
                isLoading={resourceListLoading}
                onActionChange={actionHandler}
              />
            </div>
          </div>) : (
          <DataLoader />
        )}
    </>
  );
};
export default ResourceList;
